<template>
  <header class="gridx">
    <vs-navbar 
      
      v-model="indexActive"
      :color="topbarColor"
      class="topnavbar"
      back
      text-color="red"
      active-text-color="red"
    >
      <!---
      Template logo
      -->
      <div slot="title" class="themelogo">
        <img :src="logo" v-if="logo" alt="Dashboard" width="200px" />
        <span class="logo-text" v-if="title">{{ title }}</span>
      </div>
      <!---
      Mobile toggle
      -->
      <div slot="title">
        <div class="hiddenDesktop cursor-pointer" @click.stop="activeSidebar">
          <vs-icon color="primary" icon="menu"></vs-icon>
        </div>
      </div>
     
      <vs-spacer></vs-spacer>

    
       <!---
      Craete new dd
      -->
       <!-- <vs-row vs-w="2">
        <input class="search__input" type="text" placeholder="Search">
       
        </vs-row>&nbsp;&nbsp; -->
        

      <!---
      Craete new dd
      -->
      
      <a class="mr-2" style="color:#5b5777; " href="#">Hi, {{this.$session.get('username')}}</a>
     <!-- <vs-icon icon="notifications_active" size="27px" color="success"></vs-icon> -->
       <vs-dropdown >
          <span v-if="this.username != 'poonsak.ngk'">
            <vs-avatar icon="notifications" size="27px" color="grey" v-if="alertlist.length == 0"></vs-avatar>
            <vs-avatar icon="notifications_active" size="27px" color="danger" :badge="alertlist.length" v-else></vs-avatar>
          </span>
        <vs-dropdown-menu class="loginx">
        <vs-list>
    <vs-list-header icon="notifications_active" color="warning" title="Alert"></vs-list-header>
    <vs-list-item v-for="(item,i) in alertlist" :key="i" icon="check" :title="item.alertname" :subtitle="item.timestamp">
      <vs-button type="filled" to='/Alert'>Disarm</vs-button>
    </vs-list-item>
  </vs-list>
      </vs-dropdown-menu>
    </vs-dropdown>
      <!---
      Craete new dd
      -->
      <vs-dropdown vs-trigger-click left class="cursor-pointer pr-2 pl-2 ml-1 mr-1">
        <!-- <a class="text-dark" href="#">
         
          <vs-button radius color="#5b5777" type="gradient" icon="person"></vs-button>
        </a> -->
        <span>
  <vs-icon icon="person" size="27px" color="#5b5777"></vs-icon>
</span>
        <vs-dropdown-menu class="topbar-dd">
          <vs-dropdown-item @click="logout">Log Out</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-navbar>
  </header>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    topbarColor: {
      type: String,
      default: "#4F5467"
    },
    title: {
      type: String
    },
    logo: {
      type: String
    }
  },
  data: () => ({
    indexActive: 0,
    showToggle: false,
    search: "",
    alertlist: [],
    username: ''
  }),

  methods: {
    logout() {
      this.$session.clear()
      this.$router.push({path:'/login'})
    },
    //This is for sidebar trigger in mobile
    activeSidebar() {
      this.$store.commit("IS_SIDEBAR_ACTIVE", true);
    }
  },
  created() {
    var tempel = {}
    var j = 0
    this.username = this.$session.get('username')
    this.$http.get(this.$url2+'getalertlog/'+this.username).then((result) => {
      // this.alertlist = result.data
      // console.log(result.data)
      result.data.forEach((element,i) => {
        element.alerthistory.forEach(el => {
          if(tempel.alertstatus == true) {
            tempel = el
            tempel.alertname = element.alertname
            tempel.alertstatus = element.alertstatus
            tempel.sensorname = element.sensorname
            // if(j == 0) {
            //   this.alertlist.push(el)
            //   j++
            // }
            // if(j != 0 && this.alertlist[j].name != this.alertlist[j-1].name) {
            //   this.alertlist.push(el)
            //   j++
            // }
            this.alertlist.push(el)
            tempel = {}
            }
        });
      });
      // console.log(this.alertlist)
    })
  }
};
</script>
<style lang="stylus">
.vs-con-input{
  
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 25px;
}
.search {
    &__container {
        padding-top: 64px;
    }
    
    &__title {
        font-size: 22px;
        font-weight: 900;
        text-align: center;
        color: #ff8b88;
    }
    
    &__input {
        width: 100%;
        padding: 12px 24px;

        background-color: transparent;
        transition: transform 250ms ease-in-out;
        font-size: 14px;
        line-height: 18px;
        
        color: #575756;
        background-color: transparent;
/*         background-image: url(http://mihaeltomic.com/codepen/input-search/ic_search_black_24px.svg); */
 
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: 18px 18px;
        background-position: 95% center;
        border-radius: 50px;
        border: 1px solid #575756;
        transition: all 250ms ease-in-out;
        backface-visibility: hidden;
        transform-style: preserve-3d;
        
        &::placeholder {
            color: color(#575756 a(0.8));
            text-transform: uppercase;
            letter-spacing: 1.5px;
        }
        
        &:hover,
        &:focus {
            padding: 12px 0;
            outline: 0;
            border: 1px solid transparent;
            border-bottom: 1px solid #575756;
            border-radius: 0;
            background-position: 100% center;
        }
    }
}

.credits {
    &__container {
        margin-top: 24px;
    }
    
    &__text {
        text-align: center;
        font-size: 13px;
        line-height: 18px;
    }
    
    &__link {
        color: #ff8b88;
        text-decoration: none;
        transition: color 250ms ease-in;
        
        &:hover,
        &:focus {
            color: color(#ff8b88 blackness(+25%));
        }
    }
}
</style>
<style scoped>
.con-vs-dropdown--menu {
  width: 350px;
}
</style>

